import React from "react";
import { Pause, Play, X, Film, Music, Loader2 } from "lucide-react";

// Live upload cards: thumbnail, progress bar, pause / resume and cancel.
const Thumb = ({ u }) => {
  if (u.kind === "image") return <img src={u.thumb} alt="" className="w-full h-full object-cover" />;
  if (u.kind === "video") return <video src={`${u.thumb}#t=0.1`} muted preload="metadata" className="w-full h-full object-cover" />;
  return <div className="w-full h-full flex items-center justify-center">{u.kind === "audio" ? <Music className="w-5 h-5 text-zinc-500" /> : <Film className="w-5 h-5 text-zinc-500" />}</div>;
};

const UploadCard = ({ u, onPause, onCancel }) => (
  <div className="flex items-center gap-3 rounded-xl border border-zinc-800 bg-[#0D1016] p-2 pr-3" data-testid={`media-upload-card-${u.id}`}>
    <span className="h-12 w-20 rounded-md overflow-hidden bg-black shrink-0"><Thumb u={u} /></span>
    <div className="flex-1 min-w-0">
      <div className="flex items-center gap-2 text-xs">
        <span className="truncate text-zinc-200" data-testid={`media-upload-name-${u.id}`}>{u.name}</span>
        <span className="ml-auto font-mono text-[10px] text-zinc-400 shrink-0" data-testid={`media-upload-status-${u.id}`}>
          {u.phase === "optimizing" ? "Saving…" : u.paused ? `Paused · ${u.pct}%` : `${u.pct}%${u.eta ? ` · ${u.eta}s left` : ""}`}</span>
      </div>
      <div className="mt-1.5 h-1.5 rounded-full bg-zinc-800 overflow-hidden">
        <div className={`h-full transition-[width] duration-300 ${u.paused ? "bg-amber-400" : "bg-[#7AF25F]"}`} style={{ width: `${u.pct}%` }} data-testid={`media-upload-bar-${u.id}`} />
      </div>
    </div>
    {u.phase === "optimizing" ? <Loader2 className="w-4 h-4 animate-spin text-[#7AF25F]" /> : (
      <>
        <button type="button" onClick={() => onPause(u)} title={u.paused ? "Resume" : "Pause"} data-testid={`media-upload-pause-${u.id}`}
          className="h-8 w-8 rounded-full border border-zinc-700 text-zinc-300 hover:text-white flex items-center justify-center">{u.paused ? <Play className="w-3.5 h-3.5" /> : <Pause className="w-3.5 h-3.5" />}</button>
        <button type="button" onClick={() => onCancel(u)} title="Cancel upload" data-testid={`media-upload-cancel-${u.id}`}
          className="h-8 w-8 rounded-full border border-zinc-700 text-zinc-300 hover:bg-red-500/80 hover:text-white flex items-center justify-center"><X className="w-3.5 h-3.5" /></button>
      </>
    )}
  </div>
);

export default function UploadQueue({ items, onPause, onCancel }) {
  if (!items.length) return null;
  return (
    <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-2 mb-5" data-testid="media-upload-queue">
      {items.map((u) => <UploadCard key={u.id} u={u} onPause={onPause} onCancel={onCancel} />)}
    </div>
  );
}
